import { useTranslation } from 'react-i18next';
import { formatPrice } from '@/utils/prices';
import { StripePrice } from '@/utils/types';
// import { WEB_BASE_URL } from '@/utils/config';
import { useCartContext } from '@/contexts/cartContext';
import { useAuthContext } from '@/contexts/authContext';

type PaymentNoticeProps = {
  prices: StripePrice[];
  totalWithoutVat: number;
};

export default function PaymentNotice({ prices, totalWithoutVat }: PaymentNoticeProps) {
  const { t } = useTranslation();
  const { currency } = useCartContext();
  const { region } = useAuthContext();
  const price = prices[0];

  if (!price) return null;

  return (
    <div className="flex justify-between flex-col pt-3 text-xs text-secondary-foreground font-thin line-height-tight ">
      <p>
        {price.recurring.interval == 'month'
          ? t('Web_Autorenewing_MonthlySubscription')
          : t('Web_Autorenewing_YearlySubscription')}
      </p>
      <p>{t('Web_Email_Cancellation')}</p>
      <p>{t('Web_Invoicing_Price', { PRICE: formatPrice(totalWithoutVat, currency) })}</p>
      <p
        dangerouslySetInnerHTML={{
          __html: t('Web_Disabling_Autorenewing').replace(
            'https://web.archireport.com',
            `<a class='text-blue-600 hover:underline' href='${region?.web}/web/subscription'>${region?.web}/web/subscription</a>`
          ),
        }}
      ></p>
    </div>
  );
}
